import { dataLayerPush } from 'src/helpers/gtm';
import type {
  AuthMethodsForAnalytics,
  LoginFormTypeForAnalytics,
} from './types';

export const pushAuthOpen = () => {
  dataLayerPush({ event: 'auth_open' });
};

export const pushAuthContinue = (type: LoginFormTypeForAnalytics) => {
  dataLayerPush({ event: 'auth_continue', type });
};

export const pushAuthSuccessful = (loginMethod: AuthMethodsForAnalytics) => {
  dataLayerPush({ event: 'auth_success', type: loginMethod });
};
